<template>
    <v-container
     v-if="finalData"
     class="d-flex justify-center">
        <v-row>
            <v-col cols="2"></v-col> 
            <v-col cols="8">
                <p class="text-h4 font-weight-medium text-center my-2 text-blue-grey-darken-2">
                 Finale Ansicht deiner Präsentation
                </p>
                <TreeFileView v-if="finalData.finalFile" :zipFile="finalData.finalFile" :activate-download="true" />
                <v-sheet class="elevation-5" >
                    <PDFView 
                    :source="finalData?.finalPdfSource" 
                    :page="-1" 
                    @loaded="onPdfLoaded" 
                    />
                    <v-sheet 
                    height="auto" max-height="700px" 
                    class="pl-2 pr-2 w-auto overflow-y-auto hidden-scrollbar
                        d-flex flex-column align-center
                        bg-blue-grey-lighten-5
                        elevation-4"
                    >
                        <div 
                        v-for="page in totalPages" 
                        :key="page" 
                        class="mb-0"
                        >
                            <p class="pt-0 text-left text-h6 font-weight-light">{{ page }}</p>
                            <PDFView 
                            class="elevation-5 h-auto w-auto " 
                            :source="finalData?.finalPdfSource" 
                            :page="page" 
                            :scale="1.5"
                            />
                        </div>
                    </v-sheet>
                </v-sheet>
            </v-col>
            <v-col cols="2"></v-col>
        </v-row>
    </v-container>
</template>

<script lang="ts">
import { FinalData } from '@/types/finaldata';
import { defineComponent } from 'vue';
import PDFView from 'vue-pdf-embed';
import TreeFileView from './TreeFileView.vue';
export default defineComponent({
    name: 'FinalPreview-Componenten',

    props: {
        finalData: Object as () => FinalData | null,
    },

    components: {
        PDFView,
        TreeFileView,
    },
    data() {
        return {
            totalPages: 0 as number,
        };
    },
    methods: {
        onPdfLoaded(pdf: any) {
            this.totalPages = pdf.numPages;
        },
    },
});
</script>